import React, { Dispatch, SetStateAction } from 'react';
import { UsePagination } from '@/components/blocks/UsePagination';
import { useIsMobile } from '@/data/hooks/useIsMobile';

interface PaginatorProps {
	children: React.ReactNode;
	page: number;
	setPage: Dispatch<SetStateAction<number>>;
}

export const Paginator: React.FC<PaginatorProps> = ({ children, page, setPage }) => {
	const isMobile = useIsMobile();

	const itemsPerPage = isMobile ? 3 : 9;

	const handleChangePage = (_: unknown, newPage: number) => {
		setPage(newPage - 1);
	};

	const childrenArray = React.Children.toArray(children).filter((item) => typeof item === 'object');

	const startIndex = page * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const displayedChildren = childrenArray.slice(startIndex, endIndex);
	const count = Math.ceil(childrenArray.length / itemsPerPage);

	return (
		<React.Fragment>
			{displayedChildren}
			<UsePagination count={count} onChange={handleChangePage} />
		</React.Fragment>
	);
};
